import ExcelJS from "exceljs";
import saveAs from "file-saver";
import { UIUtilTime } from "../../util/Time";

export namespace ExcelThingsUtil {

    export const ABCCOLS = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

    export function _LoadWorkbook(file: File): Promise<ExcelJS.Workbook> {
        return new Promise((resolve, reject) => {
            let fileReader = new FileReader();

            fileReader.onloadend = async e => {
                let wb = new ExcelJS.Workbook();
                await wb.xlsx.load(fileReader.result as ExcelJS.Buffer);
                resolve(wb);
            };
            fileReader.onerror = e => {
                console.warn("-d", "Error onload file: ", e);
                reject(e);
            };
            fileReader.onabort = (e) => {
                console.warn("-d", "Error onabort file", e);
                reject(e);
            }

            fileReader.readAsArrayBuffer(file);
        })
    }

    export function _DownloadWorkbook(libro: ExcelJS.Workbook, fileName: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            libro.xlsx.writeBuffer({ useStyles: true }) // DOTEST
                .then((dataBuffer) => {
                    const blobOptions: BlobPropertyBag = {
                        type: " application/vnd.openxmlformats-officedocument. spreadsheetml.sheet",
                    }
                    const blob = new Blob([dataBuffer], blobOptions);

                    saveAs(blob, (fileName + "_" + UIUtilTime._DateFormatStandar(new Date())) + ".xlsx");
                    resolve(true);
                })
                .catch(() => reject(false));
        })
    }

    // ***** DELETE ? ******
    export interface IInfoImagenExcel {
        type: string; // "image";
        imageId: string;
        range: ExcelJS.ImageRange;
    }
    // ****************+
    export interface IConfigLogo {
        // /** Nombre de la hoja (Único) */
        // Nombre: string;
        Logo: File;
        IdExcelImagen: number;
        ExcelLogoWidth: number;
        ExcelLogoHeight: number;
    }
    export function _ReadLogo(book: ExcelJS.Workbook, logo: File, fileName: string, infoLogoOriginal: IInfoImagenExcel): Promise<IConfigLogo> {
        let configHoja: IConfigLogo = {
            Logo: logo,
            IdExcelImagen: -1,
            ExcelLogoHeight: 5,
            ExcelLogoWidth: 5
        }

        return new Promise((resolve, reject) => {
            let fileReader: FileReader = new FileReader();

            fileReader.onloadend = (e) => {
                let imagen = new Image();

                configHoja.IdExcelImagen = book.addImage({
                    base64: <string>fileReader.result,
                    extension: "png"
                });

                imagen.onload = (e) => {
                    let propor = (infoLogoOriginal ? infoLogoOriginal.range["ext"].height * 100 / imagen.height : 100) / 100;

                    configHoja.ExcelLogoWidth = imagen.width * propor;
                    configHoja.ExcelLogoHeight = imagen.height * propor;
                    // resolve(configHoja.IdExcelImagen);
                    resolve(configHoja);
                }
                imagen.onerror = () => {
                    console.warn("-d", "Error (2) al leer el logo de " + fileName);
                    // configHoja.IdExcelImagen = -2;
                    reject(null);
                }
                imagen.src = <string>fileReader.result
            }

            fileReader.onerror = (e) => {
                console.warn("-d", "Error (1) al leer el logo de " + fileName);
                reject(null);
            }

            fileReader.readAsDataURL(logo);
        })
    }
}